import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Pipe, NgModule } from '@angular/core';
import { strings } from '@niceltd/sol';
class TranslationService {
  constructor() {
    this.strings = strings.dscomponents;
  }
  setTranslations(values) {
    this.strings = Object.assign({}, this.strings, values);
  }
  getTranslation(key, ...params) {
    if (!key) {
      return '';
    }
    if (!this.strings) {
      console.warn('keys not loaded: ', key);
      return '';
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let value = this.strings[key];
    if (!value) {
      console.warn(`Translation key not found: ${key}.`);
      return '';
    }
    if (params) {
      params.forEach((param, index) => value = value.replace(`{${index}}`, param.toString()));
    }
    return value;
  }
  static {
    this.ɵfac = function TranslationService_Factory(t) {
      return new (t || TranslationService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TranslationService,
      factory: TranslationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class TranslationPipe {
  constructor(translationService) {
    this.translationService = translationService;
  }
  transform(key, ...params) {
    return this.translationService.getTranslation(key, ...params);
  }
  static {
    this.ɵfac = function TranslationPipe_Factory(t) {
      return new (t || TranslationPipe)(i0.ɵɵdirectiveInject(TranslationService, 16));
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "translate",
      type: TranslationPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationPipe, [{
    type: Pipe,
    args: [{
      name: 'translate'
    }]
  }], () => [{
    type: TranslationService
  }], null);
})();
class TranslationModule {
  static {
    this.ɵfac = function TranslationModule_Factory(t) {
      return new (t || TranslationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TranslationModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationModule, [{
    type: NgModule,
    args: [{
      declarations: [TranslationPipe],
      imports: [CommonModule],
      exports: [TranslationPipe]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TranslationModule, TranslationPipe, TranslationService };
